<div class="flex justify-center items-center h-screen transition-colors px-5">
  <img src="assets/images/cmaxhm-logo.png" alt="Cmaxhm Logo" class="w-44">
</div>
